import Vue from "vue";

Vue.mixin({
  methods: {
    formatDate(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      if (isNaN(parsedDate.getTime())) return "";
      return parsedDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  }
});
